import { useT } from "../lib/i18n";

export function HowItWorks() {
  const t = useT();

  return (
    <section
      id="how-it-works"
      className="border-t border-margin dark:border-paper/10 bg-margin/20 dark:bg-paper/[0.02]"
    >
      <div className="mx-auto max-w-6xl px-6 py-24">
        <div className="max-w-2xl">
          <p className="text-xs font-medium uppercase tracking-wider text-ink/50 dark:text-paper/50">
            {t.howItWorks.label}
          </p>
          <h2 className="mt-2 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-ink dark:text-paper">
            {t.howItWorks.heading}
          </h2>
        </div>

        <ol className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-margin bg-margin sm:grid-cols-2 lg:grid-cols-3 dark:border-paper/10 dark:bg-paper/10">
          {t.howItWorks.steps.map((s) => (
            <li key={s.n} className="bg-paper p-6 dark:bg-ink">
              <div className="font-mono text-xs text-ink/40 dark:text-paper/40">
                {s.n}
              </div>
              <h3 className="mt-4 font-display text-lg font-semibold text-ink dark:text-paper">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/70 dark:text-paper/70">
                {s.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
